import React, { useEffect, useState } from 'react';
import { getHomePage, getHomePageBoards, updatePinnedWidgets } from '../../../../common/services/http/homeService';
import useTranslate from '../../../../common/hooks/useTranslate';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import arrayMove from '../../../../common/utility/arrayMove';

import { IWidget } from '../../../dashboards/types/IWidget';

import OutletLoader from '../../../ui/loaders/outletLoader/outletLoader';
import WidgetWrap from './widgetWrap/widgetWrap';
import CustomisationGuide from '../../../dashboards/components/customisationGuide/customisationGuide';
import Icon from '../../../ui/icon/icon';

import '../../../dashboards/pages/boards/board.scss';
import './widgetPinSection.scss';

const WidgetPinSection: React.FC = () => {
  const [widgets, setWidgets] = useState<IWidget[]>([]);
  const [initialWidgets, setInitialWidgets] = useState<IWidget[]>([]);
  const [unpinTrigger, setUnpinTrigger] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [customisation, setCustomisation] = useState<boolean>(false);
  const [newIndex, setNewIndex] = useState(null);
  const [oldIndex, setOldIndex] = useState(null);
  const [widgetToMove, setWidgetToMove] = useState(null);

  const impersonate = useSelector((state: RootState) => state.impersonate);

  const { t } = useTranslate();

  const handleUnpin = () => {
    setUnpinTrigger(!unpinTrigger);
  };

  const saveCustomisation = () => {
    updatePinnedWidgets(widgets).then(() => {
    });
  };

  const handleSetCustomisation = (e) => {
    if (e === true) {
      setInitialWidgets([...widgets]);
    }
    setCustomisation(e);
  };

  const handleCancel = () => {
    setWidgets([...initialWidgets]);
  };

  const handleWidgetMove = (e) => {
    setWidgetToMove(e);
  };

  const handleWidgetChange = (e) => {
    setWidgets(e);
  };

  const changeNewIndex = (e) => {
    setNewIndex(e);
  };

  const changeOldIndex = (e) => {
    setOldIndex(e);
  };

  useEffect(() => {
    let newArray = arrayMove(widgets, oldIndex, newIndex);
    setWidgets(newArray);
  }, [oldIndex, newIndex, widgetToMove]);

  useEffect(() => {
    getHomePage().then((homePageResult) => {
      setLoading(true);
      return homePageResult;
    }).then((homePageResult) => {
      const widgetsToShow = homePageResult.content;
      getHomePageBoards().then((homePageBoardsResult) => {
        let widgetsLocal: IWidget[] = [];
        widgetsToShow.forEach((widgetToShow) => {
          const widgetId = widgetToShow.widgetId;
          const id = widgetToShow.id;
          const contentId = widgetToShow.contentId;
          const widgetTitle = widgetToShow.title;
          const investorObjectId = widgetToShow.investorObjectId;

          const board = homePageBoardsResult.find((item) => {
            return item.id === contentId;
          });

          if (board && board.timePeriods.length > 0) {
            const object = board.objects.find((item) => {
              return item.objectPath === widgetToShow.objectPath;
            });

            const widget = board.widgets.find((item) => {
              return item.id === widgetId;
            });

            const data: IWidget = {
              scenarios: board.scenarios,
              widget: { ...widget, name: widgetTitle },
              setup: widget.setup,
              measures: board.measures,
              periods: board.timePeriods,
              notes: null,
              boardId: board.id,
              staticProperties: null,
              customisation: null,
              type: widget.type,
              widgets: board.widgets,
              handleWidgetChange: null,
              handleWidgetMove: null,
              changeNewIndex: null,
              changeOldIndex: null,
              boardSelectedCurrency: board.scenarios[0].currencies[0],
              selectedObject: object,
              selectedPeriod: board.timePeriods[board.timePeriods.length - 1],
              investorObjectId: investorObjectId,
              homePage: true,
              unpinId: id,
            };
            widgetsLocal.push(data);
          }
        });
        setWidgets(widgetsLocal);
        setLoading(false);
      });
    });
  }, [unpinTrigger]);

  return (
    widgets && widgets.length > 0 &&
    <div className='widget-pin-section'>
      <p className='section-title'>{t('HOME.ANALYSIS_PIN_TITLE')}</p>
      {!impersonate.impersonate && <Icon name={'fa-solid fa-gear'} className={'pointer settings-icon'}
                                         onClick={() => handleSetCustomisation(true)} />
      }
      {loading ? (
        <OutletLoader />
      ) : (
        <div className='boards-grid-container widget-pin-section-container'>
          {widgets && widgets.map((widget) => {
            return widget && (
              <WidgetWrap handleWidgetChange={handleWidgetChange}
                          handleWidgetMove={handleWidgetMove}
                          changeNewIndex={changeNewIndex}
                          changeOldIndex={changeOldIndex}
                          handleUnpin={handleUnpin}
                          widgets={widgets}
                          widget={widget}
                          customisation={customisation}
                          key={`${widget.widget.id}${widget.selectedObject.objectPath}${widget.investorObjectId}`} />
            );
          })}
        </div>
      )}
      <CustomisationGuide customisation={customisation} saveCustomisation={saveCustomisation}
                          handleCustomisation={handleSetCustomisation} handleCancel={handleCancel} noReset={true} />
    </div>
  );
};

export default WidgetPinSection;
